import TagManager from 'react-gtm-module';

import { IS_PRODUCTION } from 'utils/envs';

export enum AnalyticsEvent {
  PAGE_CHANGE = 'page_change',
  PAGE_LOADED = 'page_loaded',
  MAIN_SLIDER_CLICK = 'main_slider_click',
  MAIN_NEWS_ITEM_CLICK = 'main_news_item_click',
  MAIN_NEWS_SHOW_ALL_CLICK = 'main_news_show_all_click',
  MAIN_CONTENT_ITEM_CLICK = 'main_content_item_click',
  MAIN_CONTENT_SHOW_ALL_CLICK = 'main_content_show_all_click',
  MAIN_EVENTS_PREVIEW_CLICK = 'main_events_preview_click',
  MAIN_EVENTS_SHOW_ALL_CLICK = 'main_events_show_all_click',
  EVENTS_FILTER_SELECT = 'events_filter_select',
  EVENTS_PREVIEW_CLICK = 'events_preview_click',
  CONTENT_SLIDER_ITEM_CLICK = 'content_slider_item_click',
  CONTENT_FILTER_SELECT = 'content_filter_select',
  CONTENT_ITEM_CLICK = 'content_item_click',
  NEWS_ITEM_CLICK = 'news_item_click',
  LOGIN = 'login',
  PROFILE_CHANGE_AVATAR_CLICK = 'profile_change_avatar_click',
  PROFILE_CHANGE_AVATAR_COMPLETE = 'profile_change_avatar_complete',
  PROFILE_SAVE_PERSONAL_DATA = 'profile_save_personal_data',
  PROFILE_SAVE_TOPICS = 'profile_save_topics',
  EVENT_REGISTRATION_BTN_CLICK = 'event_registration_btn_click',
  REGISTER_EVENT = 'register_event',
  EVENT_OTHER_EVENTS_BTN_CLICK = 'event_other_events_btn_click',
  EVENT_DESCRIPTION_MORE_BTN_CLICK = 'event_description_more_btn_click',
  EVENT_TELEGRAM_BOT_CONNECT = 'event_telegram_bot_connect',
  QUIZ_REGISTRATION_CLICK = 'quiz_registration_click',
  QUIZ_REGISTRATION_COMPLETE = 'quiz_registration_complete',
  QUIZ_RULES_CLICK = 'quiz_rules_click',
  LECTURERS_LEAGUE_REGISTRATION_CLICK = 'lecturers_league_registration_click',
  LECTURERS_LEAGUE_REGISTRATION_COMPLETE = 'lecturers_league_registration_complete',
  SPECIAL_PROJECT_ITEM_CLICK = 'special_project_item_click',
  SEARCH_ACTION = 'search_action',
}

/**
 * Отправка ивентов в аналитику через GTM-апи
 * @param event - произвольное название ивента
 * @param params - произвольный список дополнительных параметров
 */
export const trackAnalyticsData = (event: string, params: any = {}) => {
  if (IS_PRODUCTION) {
    TagManager.dataLayer({
      dataLayer: {
        event: 'trackAnalytics',
        payload: {
          event,
          params,
        },
      },
    });
  } else {
    console.log(`Event - ${event}, Params - ${JSON.stringify(params)}`);
  }
};
